module.exports = __webpack_public_path__ + "img/LogoDashboard-34.c266c901.svg";